

export class Outcome {
    Id: number;
    Name: string;
    OrderBy: number;

    constructor(id: number, name: string, ordering: number) { this.Id = id; this.Name = name; this.OrderBy = ordering; }
}

export class OutcomeEvent {

    StudyId: number;
    SiteNumber: number;
    AppendixId: number;
    OutcomeId: number;
    OutcomeStatusId: number;
    ReasonId: number;
    SubjectId: string;

    initialize(): void {

        //increment ReasonIds to be able to overload status logic
        if (this.ReasonId != undefined) { this.ReasonId += 100; }

        //if (this.SubjectId == "VI0680001") console.log(this);

    }
}
